import { createFileRoute } from '@tanstack/react-router'
import { MarketingHome } from '@/components/admin/marketing/proactive/MarketingHome'

// The Marketing Overview (F-MKT-N1): headline, Next moves, coming up,
// running now. The detailed numbers are at /admin/marketing/performance.
export const Route = createFileRoute('/admin/marketing/overview')({
  component: () => <MarketingHome />,
})
